(function() {
  if (window.bgtcgAddToCartReady) return;
  window.bgtcgAddToCartReady = true;

  function setButtonLabel(button, text) {
    var label = button && button.querySelector('span');
    if (label) {
      label.textContent = text;
    } else if (button) {
      button.textContent = text;
    }
  }

  function updateCartCount(count) {
    var targets = [
      document.querySelector('#cart-icon-bubble .header__icon-btn-label'),
      document.querySelector('#cart-icon-bubble-mobile .header__icon-btn-label')
    ];

    targets.forEach(function(target) {
      if (target) target.textContent = 'Cart(' + count + ')';
    });

    ['#cart-icon-bubble', '#cart-icon-bubble-mobile'].forEach(function(selector) {
      var cart = document.querySelector(selector);
      if (!cart || count <= 0) return;

      var bubble = cart.querySelector('.cart-count-bubble');
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        cart.appendChild(bubble);
      }

      var visibleCount = bubble.querySelector('[aria-hidden]');
      if (visibleCount) visibleCount.textContent = count;

      var hiddenCount = bubble.querySelector('.visually-hidden');
      if (hiddenCount) hiddenCount.textContent = count + ' items';
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response) {
        return response.text().then(function(text) {
          if (!response.ok) throw text;
          return text ? JSON.parse(text) : {};
        });
      })
      .then(function(cart) {
        updateCartCount(cart.item_count || 0);
        return cart;
      });
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();

    if (typeof drawer.refreshContents === 'function') {
      return drawer.refreshContents();
    }

    return fetch('/cart?section_id=cart-drawer', {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function(response) { return response.text(); })
      .then(function(text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var sourceInner = html.querySelector('#CartDrawer .drawer__inner') || html.querySelector('.drawer__inner');
        var targetInner = drawer.querySelector('.drawer__inner');
        if (sourceInner && targetInner) targetInner.replaceWith(sourceInner);
      });
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      return response.text().then(function(text) {
        if (!response.ok) throw text;
        return text ? JSON.parse(text) : {};
      });
    });
  }

  function getInventoryLimit(button) {
    var rawLimit = button && button.getAttribute('data-inventory');
    var limit = rawLimit ? parseInt(rawLimit, 10) : 0;
    return limit > 0 ? limit : 0;
  }

  function getCartQuantity(cart, variantId) {
    var items = cart && cart.items ? cart.items : [];
    return items.reduce(function(total, item) {
      return String(item.variant_id) === String(variantId) ? total + (item.quantity || 0) : total;
    }, 0);
  }

  function resetButton(button) {
    setButtonLabel(button, 'ADD TO CART');
    button.style.background = '#F7B500';
    button.style.color = '#111111';
    button.disabled = false;
    if (button.dataset) delete button.dataset.bgtcgAdding;
  }

  function describeCartError(error) {
    var text = error && (error.description || error.message || error.status);
    if (!text) return 'ERROR';
    text = String(text).toUpperCase();

    if (text.indexOf('SOLD OUT') !== -1 || text.indexOf('UNAVAILABLE') !== -1) return 'SOLD OUT';
    if (text.indexOf('IN CART') !== -1 || text.indexOf('ALREADY') !== -1 || text.indexOf('MAX') !== -1) return 'IN CART';
    return 'ERROR';
  }

  function addVariant(variantId, quantity) {
    var params = new URLSearchParams();
    params.append('id', variantId);
    params.append('quantity', quantity);

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: params.toString()
    })
      .then(function(response) {
        return response.text().then(function(text) {
          var payload = null;

          try {
            payload = text ? JSON.parse(text) : {};
          } catch (error) {
            payload = { ok: response.ok, raw: text };
          }

          if (!response.ok) throw payload;
          return payload;
        });
      });
  }

  function looksLikeVerificationPage(error) {
    var raw = '';
    if (typeof error === 'string') {
      raw = error;
    } else if (error && error.raw) {
      raw = error.raw;
    } else if (error && error.description) {
      raw = error.description;
    }

    raw = String(raw).toLowerCase();
    return raw.indexOf('<!doctype html') !== -1 ||
      raw.indexOf('<html') !== -1 ||
      raw.indexOf('verifying your connection') !== -1 ||
      raw.indexOf('__cf_chl') !== -1;
  }

  function submitAddFallback(variantId, quantity) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = (window.routes && window.routes.cart_add_url) || '/cart/add';
    form.style.display = 'none';

    [
      ['id', variantId],
      ['quantity', quantity],
      ['return_to', window.location.pathname + window.location.search]
    ].forEach(function(pair) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = pair[0];
      input.value = pair[1];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  window.bgtcgAddToCart = function(button, event) {
    event = event || window.event;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    if (!button || button.disabled || (button.dataset && button.dataset.bgtcgAdding === 'true')) return false;

    if (button.dataset) button.dataset.bgtcgAdding = 'true';

    var form = button.closest('form');
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId && form) {
      var variantInput = form.querySelector('[name="id"]');
      if (variantInput) variantId = variantInput.value;
    }

    var qtyWrap = button.closest('.bgtcg-qty-wrap');
    var qtyInput = qtyWrap ? qtyWrap.querySelector('[name="quantity"]') : null;
    if (!qtyInput && form) qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    if (!variantId) {
      setButtonLabel(button, 'ERROR');
      if (button.dataset) delete button.dataset.bgtcgAdding;
      window.setTimeout(function() { resetButton(button); }, 1500);
      return false;
    }

    button.disabled = true;
    setButtonLabel(button, '...');

    var inventoryLimit = getInventoryLimit(button);
    var cartPromise = inventoryLimit > 0 ? getCart().catch(function(error) {
      if (window.console && window.console.warn) {
        window.console.warn('BGTCG cart precheck skipped', error);
      }
      return null;
    }) : Promise.resolve(null);

    cartPromise
      .then(function(cart) {
        if (inventoryLimit > 0 && cart) {
          var existingQuantity = getCartQuantity(cart, variantId);
          var remainingQuantity = inventoryLimit - existingQuantity;

          if (remainingQuantity <= 0) {
            setButtonLabel(button, 'IN CART');
            window.setTimeout(function() { resetButton(button); }, 1500);
            return null;
          }

          quantity = Math.min(quantity, remainingQuantity);
        }

        return addVariant(variantId, quantity);
      })
      .then(function(payload) {
        if (!payload) return null;
        setButtonLabel(button, '✓ ADDED');
        button.style.background = '#22aa44';
        button.style.color = '#ffffff';

        refreshCartCount().catch(function(error) {
          if (window.console && window.console.warn) {
            window.console.warn('BGTCG cart count refresh failed', error);
          }
        });

        refreshCartDrawer().catch(function(error) {
          if (window.console && window.console.warn) {
            window.console.warn('BGTCG cart drawer refresh failed', error);
          }
        });

        window.setTimeout(function() {
          resetButton(button);
        }, 1500);
      })
      .catch(function(error) {
        if (window.console && window.console.warn) {
          window.console.warn('BGTCG add to cart failed', error);
        }

        if (looksLikeVerificationPage(error)) {
          setButtonLabel(button, '...');
          submitAddFallback(variantId, quantity);
          return;
        }

        setButtonLabel(button, describeCartError(error));
        button.disabled = false;
        window.setTimeout(function() { resetButton(button); }, 1500);
      });

    return false;
  };

  document.addEventListener('click', function(event) {
    var target = event.target;
    var button = target && target.closest && target.closest('.bgtcg-atc');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    window.bgtcgAddToCart(button, event);
  }, true);
})();
